export default class RemoverAsignacionCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPersonal, idAsignacionCurso) {
    try {
      const result = await this.#repository.removerAsignacionCurso(idPersonal, idAsignacionCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
